// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "2026-10-28-03-8329565d17b75d2af8ba5822aa8059058a5d934e/scripts/" + chunkId + ".js";
};